// extracted by mini-css-extract-plugin
export default {"strategy-filter-bar":"templates-market-parity-strategy-module__strategy-filter-bar","card-content":"templates-market-parity-strategy-module__card-content"};